import { render } from "./UpdatePaymentMethod.vue?vue&type=template&id=8e414068"
import script from "./UpdatePaymentMethod.vue?vue&type=script&lang=js"
export * from "./UpdatePaymentMethod.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__